import type { Emoji } from 'emoji-mart';

export function addEmoji(
    emoji: typeof Emoji.Props,
    initialValue: string,
    setValue: (value: string) => void,
    cursorPosition: number,
    setCursorPosition: (value: number) => void
) {
    const newMessage = `${initialValue.substring(0, cursorPosition)}${
        emoji.native
    }${initialValue.substring(cursorPosition)}`;
    setValue(newMessage);
    setCursorPosition(cursorPosition + newMessage.length - initialValue.length);
}
